import React from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./Component/Hero/heroSection";
import ServiceSection from "./Component/Service/serviceSection";
import WhyChooseUsSection from "./Component/WhyChoose/chooseSection";
import AboutUs from "./Component/AboutUs/aboutSection";
import Footer from "../../components/Footer/footer";
import ProjectShowcase from "./Component/Projects/project";
import './home.css';
import TrustedBrands from "./Component/TrustedBrands/TrustedBrands";
import AboutAppSection from "./Component/AboutAppSection/AboutAppSection";
import AboutAppNeedSection from "./Component/AboutAppNeedSection/AboutAppNeedSection";
import WorkflowSection from "./Component/WorkflowSection/WorkflowSection"

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>BA Code Solutions | Web Development Company in Ahmedabad</title>

        <meta
          name="description"
          content="BA Code Solutions is a web development company in Ahmedabad offering React websites, modern UI/UX design, and custom business solutions for startups and businesses."
        />

        <meta
          name="keywords"
          content="web development company Ahmedabad, react developer India, website development, frontend developer, BA Code Solutions"
        />

        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content="BA Code Solutions" />
        <meta
          property="og:description"
          content="We build modern, fast, and scalable websites using React."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://bacodesolutions.com/" />
        <meta
          property="og:image"
          content="https://bacodesolutions.com/logo192.png"
        />
      </Helmet>
      <div className="home-screen-main-container-style">
        <HeroSection />
        <TrustedBrands />
        <AboutAppSection />
        <AboutAppNeedSection />
        <WorkflowSection />

        {/* <ServiceSection /> */}
        {/* <WhyChooseUsSection /> */}
        {/* <ProjectShowcase /> */}
        {/* <AboutUs /> */}
        <Footer />
      </div>
    </>

  );
};

export default HomePage;
